import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { icons } from '../../../assets';
import { Tooltip } from 'antd';

const baseResponseCorrect = {
    "T1L1": "5",
    "T1L2": "5",
    "T1L3": "5",
    "T2L1": "5",
    "T2L2": "5",
    "T2L3": "5",
    "T3L1": "5",
    "T3L2": "5",
    "T3L3": "6",
    "T4L1": "5",
    "T4L2": "5",
    "T4L3": "10",
}

const baseResponseInicio = {
    "Inicio_1._¿Número_de_anaqueles_considerados_en_farmacia?": "C",
    "Inicio_2._¿Qué_sustenta_nuestra_estrategia_de_acomodo_de_anaqueles_y_exhibiciones?": "C",
    "Inicio_3._¿A_qué_llamamos_'Punto_caliente'?": "A",
    "Inicio_4._¿Por_qué_es_importante_contar_con_anaqueles_bien_acomodados_y_frenteados?": "B",
    "Inicio_5._¿Cuántas_exhibiciones_deben_ir_en_el_mostrador?": "A",
    "Inicio_6._Un_anaquel_se_compone_de_copete,_charola,_cintillo,_stopper_y_productos.": "A",
    "Inicio_7._El_copete_de_un_anaquel_indica_únicamente_la_fracción_del_producto.": "B",
    "Inicio_8._¿Qué_función_tiene_el_cintillo_y_el_stopper?": "C",
    "Inicio_9._¿Qué_es_un_copete?": "B",
    "Inicio_10._¿Qué_distribuciones_de_mostrador_y_anaqueles_son_más_comunes_en_nuestras_farmacias?": "C",
}

const baseResponseFinal = {
    "Final_1._¿Número_de_anaqueles_considerados_en_farmacia?": "C",
    "Final_2._¿Qué_sustenta_nuestra_estrategia_de_acomodo_de_anaqueles_y_exhibiciones?": "C",
    "Final_3._¿A_qué_llamamos_'Punto_caliente'?": "A",
    "Final_4._¿Por_qué_es_importante_contar_con_anaqueles_bien_acomodados_y_frenteados?": "B",
    "Final_5._¿Cuántas_exhibiciones_deben_ir_en_el_mostrador?": "A",
    "Final_6._Un_anaquel_se_compone_de_copete,_charola,_cintillo,_stopper_y_productos.": "A",
    "Final_7._El_copete_de_un_anaquel_indica_únicamente_la_fracción_del_producto.": "B",
    "Final_8._¿Qué_función_tiene_el_cintillo_y_el_stopper?": "C",
    "Final_9._¿Qué_es_un_copete?": "B",
    "Final_10._¿Qué_distribuciones_de_mostrador_y_anaqueles_son_más_comunes_en_nuestras_farmacias?": "C",
}

// eslint-disable-next-line
export const UserPerfilSimiAR = ({ grupo, nameUser, matricula, Fecha_y_hora }) => {
    const { arrayData } = useSelector((state) => state.table);
    const { typeAdmin } = useSelector((state) => state.auth)
    const { proyectSelected } = useSelector((state) => state.vrlSlice);
    // const { proyects } = useSelector((state) => state.vrlSlice);
    const [pageSelected, setpageSelected] = useState(0)

    const { responses } = useSelector((state) => {
        if (typeAdmin === "VRT") {
            return state.vrtSlice
        }
        else {
            return state.vrlSlice
        }
    });
    // eslint-disable-next-line
    const [dataFilterPerUser, setFileterData] = useState([])
    const [filterResponses, setfilterResponses] = useState([])

    const formatedDate = (date) => {
        const fecha = new Date(date);
        return fecha.toLocaleString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        });
    }




    const onchangePage = (next) => {
        setpageSelected(actual => {
            const suma = actual + next
            if (suma >= dataFilterPerUser.length) {
                return 0
            }
            if (suma <= -1) {
                return dataFilterPerUser.length - 1
            }
            else {
                return suma
            }

        })
    }


    useEffect(() => {

        // console.clear()
        const conjunts = arrayData
            .filter(obj => obj.matricula === matricula)
            .map(obj => ({
                ...obj,
                Fecha_y_hora: formatedDate(obj.Fecha_y_hora),

            }));
        console.log(conjunts)
        conjunts.forEach(element => {
            element.incor_T1L1 =0
            element.incor_T1L2 =0
            element.incor_T1L3 =0
            element.incor_T2L1 =0
            element.incor_T2L2 =0
            element.incor_T2L3 =0
            element.incor_T3L1 =0
            element.incor_T3L2 =0
            element.incor_T3L3 =0
            element.incor_T4L1 =0
            element.incor_T4L2 =0
            element.incor_T4L3 =0
            let corrects = 0
            let incorrects = 0

            element.tiempo_total = parseInt(element.tiempo_total.split(' ')[0])
            Object.keys(baseResponseCorrect).forEach(key => {
               if(element[key]){
                if (element[key] === baseResponseCorrect[key]) corrects++
                else if(parseInt(element[key])){
                    incorrects += Math.max(parseInt(baseResponseCorrect[key]) - parseInt(element[key]), 0)
                    element[`incor_${key}`] = Math.max(parseInt(baseResponseCorrect[key]) - parseInt(element[key]), 0)
                }
                else{
                    incorrects++
                }
               }
            })

            element.corrects = corrects
            element.incorrects = incorrects
            element.inicioCorrects = 0
            Object.keys(baseResponseInicio).forEach(key => {
                if (element[key]) {
                    if (element[key] === baseResponseInicio[key]) element.inicioCorrects += 1
                }
            })
            element.finalCorrects = 0
            Object.keys(baseResponseFinal).forEach(key => {
                if (element[key]) {
                    if (element[key] === baseResponseFinal[key]) element.finalCorrects += 1
                }
            })

        });
        console.log(conjunts)
        setFileterData(conjunts);
        //
        //
        const categories = ["Inicio_1._¿Número_de_anaqueles_considerados_en_farmacia?", "T1L1", "T1L2", "T1L3",
            "T2L1", "T2L2", "T2L3", "T3L1", "T3L2", "T3L3", "T4L1", "T4L2", "T4L3", "Final_1._¿Número_de_anaqueles_considerados_en_farmacia?"];
        let grouped = Array.from({ length: categories.length }, () => []);

        categories.forEach((key, index) => {
            conjunts.forEach(response => {
                if (response[key]) {
                    grouped[index].push(response)
                }
            })
        })
        console.log(grouped)
        setfilterResponses(grouped);
        console.log(grouped);

    }, [responses, proyectSelected, arrayData, Fecha_y_hora, matricula, typeAdmin, nameUser])


    return (
        <div className='w-full h-full flex flex-col py-6 px-10'>
            <div className=' w-full h-5/12 flex items-center'>
                <div className='w-10 h-10 rounded-full flex justify-center items-center bg-blue-600 mr-4'>
                    <p className='text-white font-semibold text-xs'> {nameUser.split(" ")[0].substring(0, 2).toUpperCase()}</p>
                </div>
                <InfoUser title={"Nombre"} text={nameUser} />
                <InfoUser title={"Matrícula"} text={matricula} />

                <InfoUser title={"Fecha y hora de registro"} text={formatedDate(Fecha_y_hora) !== "Invalid Date" ? formatedDate(Fecha_y_hora) : "Sin fecha"} />
            </div>
            <div className="pt-6">
                <p className='text-black text-base font-semibold leading-5'>{proyectSelected.name}</p>
            </div>
            <div className='w-full h-20 flex justify-start gap-x-8 py-3'>
                <div className='h-16 pr-4 border-r border-[#686868]'>
                    <p className='pb-2'>Totales</p>
                    <div className='flex justify-start gap-x-8'>
                        <div className='flex'>
                            <img src={icons.watch} className='h-6 w-6' alt="icon time total" />
                            <div className='pl-2'>
                                <p className='text-xs text-[#686868] leading-5'>Tiempo total</p>
                                <p className='text-sm font-medium text-[#282828] leading-5'>{dataFilterPerUser.reduce((sum, obj) => sum + obj.tiempo_intento, 0)} min</p>
                            </div>
                        </div>
                        <div className='flex'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M9.75 9.75L14.25 14.25M14.25 9.75L9.75 14.25M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#686868" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <div className='pl-2'>
                                <p className='text-xs text-[#686868] leading-5'>Errores Totales</p>
                                <p className='text-sm font-medium text-[#282828] leading-5'>{dataFilterPerUser.reduce((sum, obj) => sum + obj.incorrects, 0)}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=' '>
                    <p className='pb-2'>Promedios</p>
                    <div className='flex justify-start gap-x-8'>
                        <div className='flex'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M9.75 9.75L14.25 14.25M14.25 9.75L9.75 14.25M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#686868" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <div className='pl-2'>
                                <p className='text-xs text-[#686868] leading-5'>Errores promedio</p>
                                <p className='text-sm font-medium text-[#282828] leading-5'>{Math.round(dataFilterPerUser.reduce((sum, obj) => sum + obj.incorrects, 0) / dataFilterPerUser.length)}</p>
                            </div>
                        </div>
                        <div className='flex'>
                            <img src={icons.watch} className='h-6 w-6' alt="icon time total" />
                            <div className='pl-2'>
                                <p className='text-xs text-[#686868] leading-5'>Tiempo promedio</p>
                                <p className='text-sm font-medium text-[#282828] leading-5'>{Math.round(dataFilterPerUser.reduce((sum, obj) => sum + obj.tiempo_intento, 0) / dataFilterPerUser.length)} min.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className='pl-8 pt-6'>
                <p className='text-base'><strong>Repeticiones por curso</strong> ({dataFilterPerUser.length})</p>
            </div> */}
            <div className="w-full flex justify-center items-center pt-4">
                {/* {
                    dataFilterPerUser.length >= 2 &&
                    <div
                        onClick={() => { onchangePage(-1) }}
                        className='h-full flex justify-center items-center mr-4 cursor-pointer'>
                        <div className='w-10 h-10 rounded-full shadowBtnNext flex justify-center items-center'>
                            <img src={icons.mayorqueicon} className='h-6 transform rotate-180' alt="" />
                        </div>
                    </div>
                } */}
                {/*  */}
                <div className='w-[744px] h-[450px] rounded-3xl shadow-3xl py-8 px-4 '>
                    <div className='flex w-full gap-6 pb-4 justify-center '>
                        {/* <div className='flex gap-2'>
                            <img src={icons.initialDate} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868]'>Fecha inicial</p>
                                <p>{dataFilterPerUser[pageSelected]?.initialDate || 'Sin fecha'}</p>
                            </div>
                        </div> */}
                        <InfoIntent icon={icons.initialDate} title={'Primer intento'} data={dataFilterPerUser[0]?.Fecha_y_hora || 'Sin fecha'}></InfoIntent>
                        <InfoIntent icon={icons.endDate} title={'Ultimo intento'} data={dataFilterPerUser[dataFilterPerUser.length - 1]?.Fecha_y_hora || 'Sin fecha'}></InfoIntent>
                        <div className='flex gap-2'>
                            <img src={icons.progress} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868] text-xs font-medium '>Estatus</p>
                                <div className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>
                                    <p className='w-[112px] text-center leading-5 py-1'>{dataFilterPerUser[pageSelected]?.Porcentaje_total || 'Sin progreso'}</p>
                                    <div className='w-full h-1 bg-[#d9d9d9] rounded'>
                                        <div
                                            style={{ width: dataFilterPerUser[pageSelected]?.Porcentaje_total || '0%' }}
                                            className={`h-full ${dataFilterPerUser[pageSelected]?.Porcentaje_total.split('%')[0] < 100 ? 'bg-[#F2B840]' : 'bg-[#89EB7E]'} `}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className='flex gap-2'>
                            <img src={icons.progress} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868] text-xs font-medium '>Puntaje</p>
                                <div className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>
                                    <p className='w-[112px] text-center leading-5 py-1'>{dataFilterPerUser[pageSelected]?.puntaje || 'Sin puntaje'}</p>
                                    <div className='w-full h-1 bg-[#d9d9d9] rounded'>
                                        <div
                                            style={{ width: dataFilterPerUser[pageSelected]?.puntaje.split('/')[0] + '%' || '0%' }}
                                            className={`h-full ${dataFilterPerUser[pageSelected]?.puntaje.split('/')[0] < 100 ? 'bg-[#F2B840]' : 'bg-[#89EB7E]'} `}></div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        {/* <InfoIntent icon={icons.progress} title={'Progreso'} data={dataFilterPerUser[pageSelected]?.Porcentaje_total || 'Sin progreso'}></InfoIntent> */}
                        {/* <InfoIntent icon={icons.pointsSheld} title={'Puntaje'} data={dataFilterPerUser[pageSelected]?.puntaje || 'Sin puntaje'}></InfoIntent> */}
                    </div>
                    <div className='w-full h-10 bg-3366FF rounded flex'>
                        <div className='w-3/12 flex justify-start items-center px-2'>
                            <p className='text-white font-bold text-xs'>Temas</p>
                        </div>
                        <div className='w-7/12 flex justify-center items-center'>
                            <p className='text-white font-bold text-xs'>Pasos (# repeticiones por tarea)</p>
                        </div>
                        <div className='w-2/12 flex justify-center items-center'>
                            <p className='text-white font-bold text-xs'>Errores</p>
                        </div>
                        {/* <div className='w-8/12 flex justify-center items-center'>
                            <p className='text-white font-bold text-xs'>Tiempo</p>
                        </div> */}

                    </div>
                    {/* epp */}
                    <div className='h-[300px] overflow-y-auto'>
                        <div className='w-full flex py-2'>
                            <div className='w-3/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>Nuestras estrategias de ventas</p>
                            </div>
                            <div className='w-7/12 flex justify-center gap-2'>
                                <CubeIntent finded={filterResponses[1]} maxValue={5} title={"T1L1"}></CubeIntent>
                                <CubeIntent finded={filterResponses[2]} maxValue={5} title={"T1L2"}></CubeIntent>
                                <CubeIntent finded={filterResponses[3]} maxValue={5} title={"T1L3"}></CubeIntent>                               
                            </div>
                            <div className='w-2/12 flex justify-center items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>
                                    {
                                        dataFilterPerUser.reduce(
                                            (acc, curr) =>
                                                acc +
                                                (curr.incor_T1L1 || 0) +
                                                (curr.incor_T1L2 || 0) +
                                                (curr.incor_T1L3 || 0),
                                            0
                                        )
                                    }
                                </p>
                            </div>
                        </div>
                        {/* previo a utilizar  */}
                        <div className='w-full flex py-2 bg-gray-100'>
                            <div className='w-3/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>Distribución de los espacios en la farmacia</p>
                            </div>
                            <div className='w-7/12 flex justify-center gap-2'>
                                <CubeIntent finded={filterResponses[4]} maxValue={5} title={"T2L1"}></CubeIntent>
                                <CubeIntent finded={filterResponses[5]} maxValue={5} title={"T2L2"}></CubeIntent>
                                <CubeIntent finded={filterResponses[6]} maxValue={5} title={"T2L3"}></CubeIntent>                               
                                
                            </div>
                            <div className='w-2/12 flex justify-center items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>
                                    {
                                        dataFilterPerUser.reduce(
                                            (acc, curr) =>
                                                acc +
                                                (curr.incor_T2L1 || 0) +
                                                (curr.incor_T2L2 || 0) +
                                                (curr.incor_T2L3 || 0),
                                            0
                                        )
                                    }
                                </p>
                            </div>
                        </div>
                        {/* despliegue */}
                        <div className='w-full flex py-2 ' >
                            <div className='w-3/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>El valor de nuestro acomodo</p>
                            </div>
                            <div className='w-7/12 flex justify-center gap-2'>
                                <CubeIntent finded={filterResponses[7]} maxValue={5} title={"T3L1"}></CubeIntent>
                                <CubeIntent finded={filterResponses[8]} maxValue={5} title={"T3L2"}></CubeIntent>
                                <CubeIntent finded={filterResponses[9]} maxValue={6} title={"T3L3"}></CubeIntent>
                                {/* colores: 
                                rjoo:1 2 3
                                amarillo:4 5
                                verde 6
                                */}
                            </div>
                            <div className='w-2/12 flex justify-center items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>
                                    {
                                        dataFilterPerUser.reduce(
                                            (acc, curr) =>
                                                acc +
                                                (curr.incor_T3L1 || 0) +
                                                (curr.incor_T3L2 || 0) +
                                                (curr.incor_T3L3 || 0),
                                            0
                                        )
                                    }
                                </p>
                            </div>

                        </div>
                        <div className='w-full flex py-2 bg-gray-100'>
                            <div className='w-3/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>Elementos de anaqueles y exhibiciones</p>
                            </div>
                            <div className='w-7/12 flex justify-center gap-2'>
                                <CubeIntent finded={filterResponses[10]} maxValue={5} title={"T4L1"}></CubeIntent>
                                <CubeIntent finded={filterResponses[11]} maxValue={5} title={"T4L2"}></CubeIntent>
                                <CubeIntent finded={filterResponses[12]} maxValue={10} title={"T4L3"}></CubeIntent>
                                {/*rojo antes 6 
                                    amarillos  6,7,8,9 
                                    verdes 10
                                 */}
                            </div>
                            <div className='w-2/12 flex justify-center items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>
                                    {
                                        dataFilterPerUser.reduce(
                                            (acc, curr) =>
                                                acc +
                                                (curr.incor_T4L1 || 0) +
                                                (curr.incor_T4L2 || 0) +
                                                (curr.incor_T4L3 || 0),
                                            0
                                        )
                                    }
                                </p>
                            </div>

                        </div>
                        <div className='w-full flex py-2 bg-gray-100'>
                            <div className='w-3/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>Encuesta inicial Vs final</p>
                            </div>
                            <div className='w-7/12 flex justify-center gap-2'>
                                <CubeIntent finded={filterResponses[0]} maxValue={10} title={"inicioCorrects"}></CubeIntent>
                                <CubeIntent finded={filterResponses[13]} maxValue={10} title={"finalCorrects"}></CubeIntent>
                                <div className={`w-9 h-9 cursor-pointer rounded-[4px] flex justify-center items-center text-xs text-white font-semibold`}> </div>
                            </div>
                            <div className='w-2/12 flex justify-center items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>{
                                    10 - dataFilterPerUser.reduce(
                                        (acc, curr) =>
                                            acc +
                                            (curr.inicioCorrects || 0),
                                        0
                                    )
                                } / {
                                        10 - dataFilterPerUser.reduce(
                                            (acc, curr) =>
                                                acc +
                                                (curr.finalCorrects || 0),
                                            0
                                        )
                                    } </p>
                            </div>

                        </div>
                        <div className='w-full flex py-2 bg-[#686868]'>
                            <div className='w-3/12 flex justify-start items-center px-2'>
                                <p className='text-base font-normal text-white'>Total</p>
                            </div>
                            <div className='w-7/12 flex justify-center gap-2'>
                            </div>
                            <div className='w-2/12 flex justify-center items-center px-2'>
                                <p className='text-xs font-medium text-white'>
                                    {
                                        dataFilterPerUser.reduce(
                                            (acc, curr) =>
                                                acc +
                                                (curr.incorrects || 0),
                                            0
                                        )
                                    }
                                </p>
                            </div>

                        </div>
                        {/*  */}

                        {/*  */}
                    </div>
                </div>
                {/*  */}
                {/* {
                    dataFilterPerUser.length >= 2 &&
                    <div
                        onClick={() => { onchangePage(1) }}
                        className='h-full flex justify-center items-center pl-4 cursor-pointer'>
                        <div className='w-10 h-10 rounded-full shadowBtnNext flex justify-center items-center'>
                            <img src={icons.mayorqueicon} className='h-6 ' alt="" />
                        </div>
                    </div>
                } */}
            </div>
            {/* <div className='w-full flex justify-center gap-x-2 pt-4'>
                {dataFilterPerUser.length >= 2 && <PageViewer pageSelected={pageSelected} dataFilterPerUser={dataFilterPerUser.length}></PageViewer>}

            </div> */}
        </div>
    )
}


const PageViewer = ({ pageSelected, dataFilterPerUser }) => {
    const rows = []
    for (let index = 0; index < dataFilterPerUser; index++) {
        rows.push(
            <div key={index} className={`w-2 h-2 
                ${pageSelected === index ? "bg-[#14A6E0] bg-opacity-100" : "bg-black bg-opacity-40"}
                 rounded-full`}></div>
        )
    }
    return rows
}

const InfoUser = ({ title, text }) => {
    return (
        <div className='w-2/6 h-full flex items-center'>
            <p className='text-[#686868]  text-xs font-medium leading-5'>{title}: </p>
            <p className='text-[#454545] text-xs font-normal pl-2 leading-5'>{text}</p>
        </div>
    )
}

const CubeIntent = ({ finded,maxValue, title }) => {
    if (finded && finded.length > 0) {
        if (title === "T1L2") {
            // console.clear()
        }
        let value = finded[finded.length - 1][title]

        let color;
        let numericValue = parseInt(value);
        if (maxValue === 5) {
            if (numericValue > 5) {
                numericValue = 5
            }
            if (numericValue === 5) {
                color = "bg-[#89EB7E]"; // verde
            } else if ([4].includes(numericValue)) {
                color = "bg-[#d1ba00]"; // amarillo
            } else if ([0, 1, 2, 3].includes(numericValue)) {
                color = "bg-red-500"; // rojo
            } else {
                color = "bg-gray-300"; // color por defecto si el valor no es 0-5
            }
        }
        else if (maxValue === 8) {
            if (numericValue === 8) {
                color = "bg-[#89EB7E]"; // verde
            } else if ([7, 8, 9].includes(numericValue)) {
                color = "bg-[#d1ba00]"; // amarillo
            } else if ([0, 1, 2, 3, 4, 5, 6].includes(numericValue)) {
                color = "bg-red-500"; // rojo
            } else {
                color = "bg-gray-300"; // color por defecto si el valor no es 0-5
            }
        }
        else if (maxValue === 10) {
            if (numericValue === 10) {
                color = "bg-[#89EB7E]"; // verde
            } else if ([7, 8, 9].includes(numericValue)) {
                color = "bg-[#d1ba00]"; // amarillo
            } else if ([0, 1, 2, 3, 4, 5, 6].includes(numericValue)) {
                color = "bg-red-500"; // rojo
            } else {
                color = "bg-gray-300"; // color por defecto si el valor no es 0-5
            }
        }
        else if (maxValue === 6) {
            if (numericValue === 6) {
                color = "bg-[#89EB7E]"; // verde
            } else if ([4, 5].includes(numericValue)) {
                color = "bg-[#d1ba00]"; // amarillo
            } else if ([0, 1, 2, 3].includes(numericValue)) {
                color = "bg-red-500"; // rojo
            } else {
                color = "bg-gray-300"; // color por defecto si el valor no es 0-5
            }
        }
        return (
            <Tooltip placement="rightTop" title={
                <div className={`flex gap-2 w-auto flex-wrap `}>
                    {
                        finded.map((obj, index) => {
                            return <CubeIntentTootltip key={index} value={obj[title]} maxValue={maxValue}></CubeIntentTootltip>
                        })
                    }
                </div>
            } color="#2A3A45" overlayInnerStyle={{ color: "#2A3A45" }}>

                <div className={`w-9 h-9 cursor-pointer rounded-[4px] flex justify-center items-center text-xs text-white font-semibold ${color}`}>
                    {
                        parseInt(value) >= 0 &&
                        <p className='text-white font-bold text-xs'> {value}/{maxValue}</p>
                    }
                </div>
            </Tooltip>
        )
    }
    else {
        return <div className={`w-9 h-9 cursor-pointer rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-gray-300`}>
            <p className='text-white font-bold text-xs'> </p>
        </div>
    }
}

const CubeIntentTootltip = ({ value, maxValue }) => {

    let color;
    const numericValue = parseInt(value);
    if (maxValue === 5) {
        if (numericValue === 5) {
            color = "bg-[#89EB7E]"; // verde
        } else if ([4].includes(numericValue)) {
            color = "bg-[#d1ba00]"; // amarillo
        } else if ([0, 1, 2, 3].includes(numericValue)) {
            color = "bg-red-500"; // rojo
        } else {
            color = "bg-gray-300"; // color por defecto si el valor no es 0-5
        }
    }
    else if (maxValue === 10) {
        if (numericValue === 10) {
            color = "bg-[#89EB7E]"; // verde
        } else if ([7, 8, 9].includes(numericValue)) {
            color = "bg-[#d1ba00]"; // amarillo
        } else if ([0, 1, 2, 3, 4, 5, 6].includes(numericValue)) {
            color = "bg-red-500"; // rojo
        } else {
            color = "bg-gray-300"; // color por defecto si el valor no es 0-5
        }
    }
    else if (maxValue === 6) {
        if (numericValue === 6) {
            color = "bg-[#89EB7E]"; // verde
        } else if ([4, 5].includes(numericValue)) {
            color = "bg-[#d1ba00]"; // amarillo
        } else if ([0, 1, 2, 3].includes(numericValue)) {
            color = "bg-red-500"; // rojo
        } else {
            color = "bg-gray-300"; // color por defecto si el valor no es 0-5
        }
    }

    return (
        <div className={`w-9 h-9 cursor-pointer rounded-[4px] flex justify-center items-center text-xs text-white font-semibold ${color}`}>
            {
                parseInt(value) >= 0 &&
                <p className='text-white font-bold text-xs'> {value}/{maxValue}</p>
            }
        </div>
    )
}


const InfoIntent = ({ icon, title, data }) => {
    return (
        <div className='flex gap-2'>
            <img src={icon} className="w-6 h-6" alt="icono de fecha" />
            <div>
                <p className='text-[#686868] text-xs font-medium leading-5'>{title}</p>
                <p className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>{data}</p>
            </div>
        </div>
    )
}


export default UserPerfilSimiAR
